import { ReactElement, useMemo } from 'react';

import { AVAILABLE_CHAINS } from 'modules/common';
import { Layout } from 'modules/layout';
import { getAccountAddress, getChainId } from 'modules/store';

import { Connect } from './Connect';
import { UnsupportedNetwork } from './UnsupportedNetwork';

interface GuardRouteProps {
  children: ReactElement;
}

export function GuardRoute({ children }: GuardRouteProps): JSX.Element {
  const { data: currentAccount } = getAccountAddress.useQueryState();
  const { data: currentChainId } = getChainId.useQueryState();

  const isSupportedNetwork = useMemo(() => {
    if (!currentChainId) {
      return false;
    }

    return AVAILABLE_CHAINS.includes(currentChainId);
  }, [currentChainId]);

  if (!currentAccount || !currentChainId) {
    return (
      <Layout>
        <Connect />
      </Layout>
    );
  }

  if (currentAccount && !isSupportedNetwork) {
    return (
      <Layout>
        <UnsupportedNetwork />
      </Layout>
    );
  }

  return children;
}
